const EditIcon = ({
  className,
  style,
  onClick,
}: {
  className?: string;
  style?: any;
  onClick?: any;
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      onClick={onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4809 2.11782C17.1972 1.40173 18.1686 0.999507 19.1814 0.999634C20.1942 0.999761 21.1655 1.40223 21.8816 2.1185C22.5977 2.83476 22.9999 3.80616 22.9998 4.81899C22.9997 5.83183 22.5972 6.80312 21.881 7.51921L8.53409 20.8681L8.53292 20.8692C8.18518 21.2159 7.75768 21.4719 7.28792 21.6147L2.9318 22.9357C2.67247 23.0136 2.39688 23.0199 2.13428 22.9539C1.87167 22.8879 1.63182 22.752 1.44019 22.5607C1.24856 22.3694 1.1123 22.1297 1.04586 21.8672C0.979414 21.6047 0.985269 21.3291 1.0628 21.0697L1.06405 21.0656L2.38505 16.7136L2.38587 16.7109C2.52992 16.241 2.78719 15.8138 3.13504 15.4667C3.13532 15.4664 3.13559 15.4661 3.13587 15.4659L16.4809 2.11782ZM17.895 3.53221C17.8949 3.53227 17.895 3.53215 17.895 3.53221L4.54912 16.881L4.548 16.8822C4.43219 16.9976 4.34648 17.1397 4.29835 17.296C4.29824 17.2964 4.29812 17.2968 4.298 17.2972L3.25017 20.7492L6.70595 19.7013C6.86222 19.6538 7.00446 19.5687 7.12025 19.4535C7.12001 19.4537 7.12048 19.4533 7.12025 19.4535L20.4668 6.10496C20.8079 5.7639 20.9998 5.30114 20.9998 4.81874C20.9999 4.33635 20.8083 3.87368 20.4672 3.53253C20.1262 3.19138 19.6636 2.99969 19.1812 2.99963C18.6988 2.99957 18.2361 3.19125 17.895 3.53221Z"
        fill="#663497"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2929 4.29289C14.6834 3.90237 15.3166 3.90237 15.7071 4.29289L19.7071 8.29289C20.0976 8.68342 20.0976 9.31658 19.7071 9.70711C19.3166 10.0976 18.6834 10.0976 18.2929 9.70711L14.2929 5.70711C13.9024 5.31658 13.9024 4.68342 14.2929 4.29289Z"
        fill="#663497"
      />
    </svg>
  );
};

export default EditIcon;
